"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepClone = exports.getPercentAsString = exports.getColorByMark = exports.POOR_COLOUR = exports.MODERATE_COLOUR = exports.STRONG_COLOUR = exports.POOR_VALUE = exports.STRONG_VALUE = exports.titleizeArr = void 0;
var titleizeArr = function (arr) {
    return arr.map(function (item) { return ({ title: item, optionValue: item }); });
};
exports.titleizeArr = titleizeArr;
exports.STRONG_VALUE = 80;
exports.POOR_VALUE = 50;
exports.STRONG_COLOUR = '#3dc483';
exports.MODERATE_COLOUR = '#e5ba4d';
exports.POOR_COLOUR = '#f0575b';
var getColorByMark = function (num) {
    if (num < exports.POOR_VALUE)
        return exports.POOR_COLOUR;
    if (num < exports.STRONG_VALUE)
        return exports.MODERATE_COLOUR;
    return exports.STRONG_COLOUR;
};
exports.getColorByMark = getColorByMark;
var getPercentAsString = function (value, total) {
    return "".concat(Math.round((value / total) * 100), "%");
};
exports.getPercentAsString = getPercentAsString;
var deepClone = function (obj) {
    return JSON.parse(JSON.stringify(obj));
};
exports.deepClone = deepClone;
